export const DT_STACK_DIRECTION = {
  default: 'column',
  column: 'column',
  row: 'row',
  'row-reverse': 'row-reverse',
  'column-reverse': 'column-reverse',
};

export const DT_STACK_RESPONSIVE_BREAKPOINTS = ['sm', 'md', 'lg', 'xl'];

export const DT_STACK_GAP = ['0', '100', '200', '300', '400', '450', '500', '600'];

export default {
  DT_STACK_DIRECTION,
  DT_STACK_RESPONSIVE_BREAKPOINTS,
  DT_STACK_GAP,
};
